/** Replaces a soft line feed with one that will be rendered as an actual line feed so new lines isn't collapsed */
export default function (string) {
  string = string.replace(/\n/g, "&nbsp;\n");
  return string;
}
